var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { GenericComponent } from '../../atoms/GenericComponent';
import { Icon } from '../../atoms/Icon';
import { TranslatedText } from '../../atoms/TranslatedText';
export var StyledTranslatedText = styled(TranslatedText)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: 1;\n  text-align: left;\n"], ["\n  flex: 1;\n  text-align: left;\n"])));
export var RotatingIcon = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  transform: ", ";\n  transition: transform 150ms ease;\n  width: 14px;\n  background-color: black;\n  flex: none;\n"], ["\n  transform: ", ";\n  transition: transform 150ms ease;\n  width: 14px;\n  background-color: black;\n  flex: none;\n"])), function (_a) {
    var rotated = _a.rotated;
    return (rotated ? 'rotate(180deg)' : '');
});
export var ContentWrapper = styled(GenericComponent)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: ", ";\n"], ["\n  display: ", ";\n"])), function (_a) {
    var open = _a.open;
    return (open ? 'block' : 'none');
});
var templateObject_1, templateObject_2, templateObject_3;
